import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "aria-expanded"]


export default /*@__PURE__*/_defineComponent({
  __name: 'NavToggle',
  props: {
    open: { type: Boolean },
    shape: { default: 'circle' }
  },
  emits: ["toggle"],
  setup(__props: any) {

/**
 * Shared hamburger/close toggle used by both navigation menus, so the mobile
 * FAB (MobileNavMenu) and the desktop sidebar toggle (SidePanel) stay visually
 * in sync: same orange resting state, same navy open state, same bars-to-X
 * morph. Shape differs by context — circle for the floating button, rounded
 * square for the in-rail desktop one.
 */




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["nav-toggle", [`nav-toggle--${_ctx.shape}`, { 'nav-toggle--open': _ctx.open }]]),
    "aria-label": _ctx.open ? 'Close menu' : 'Open menu',
    "aria-expanded": _ctx.open,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", {
      class: "nav-toggle-bars",
      "aria-hidden": "true"
    }, [
      _createElementVNode("span", { class: "nav-toggle-bar" }),
      _createElementVNode("span", { class: "nav-toggle-bar" }),
      _createElementVNode("span", { class: "nav-toggle-bar" })
    ], -1)
  ]), 10, _hoisted_1))
}
}

})